import EmptyState from "../store/emptyState";
import { LanguageSwitcherActionConstants } from "../action-constants";
import globalReducerHelper from "./globalReducerHelper";

const { CLOSE_MENU, SET_DATA, TOGGLE_DROP_DOWN } =
  LanguageSwitcherActionConstants;

const languageSwitcher = (state = EmptyState.languageSwitcher, action) => {
  if (!state) {
    return {};
  }

  const { type, payload } = action;

  switch (type) {
    case TOGGLE_DROP_DOWN:
      return Object.assign({}, state, {
        dropDownExpand: !state.dropDownExpand
      });
    case CLOSE_MENU: {
      if (state.dropDownExpand) {
        return Object.assign({}, state, {
          dropDownExpand: !state.dropDownExpand
        });
      } else {
        return state;
      }
    }
    case SET_DATA: {
      return Object.assign({}, state, { data: action.payload });
    }

    default:
      return globalReducerHelper(
        state,
        type,
        payload && payload.languageSwitcher,
        EmptyState.languageSwitcher
      );
  }
};

export default languageSwitcher;
